import { Component, OnInit, OnDestroy } from '@angular/core';
import { DBConnectorService } from './../../service/test.service';
import { HttpClient } from '@angular/common/http';
import { SectorModel } from '../../service/sector.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-exceptions',
  templateUrl: './exceptions.component.html',
  styleUrls: ['./exceptions.component.css']
})
export class ExceptionsComponent implements OnInit, OnDestroy {
  ExceptionName:string;
  sectormodel=new SectorModel
  result: any={}
  public exceptionlist= [];
  NoWords = null;
  Sub: Subscription;

  constructor(private dbconnectorservice:DBConnectorService,private http: HttpClient) { 
    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.dbconnectorservice.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res; });
    this.Sub = this.dbconnectorservice.onGetMod.subscribe((res) => { this.sectormodel.ModelName = res; this.callIndex(); });
    
  }

  callIndex(){
    if (this.sectormodel.SectorName != null && this.sectormodel.SectorName != "null") {
      this.result = {};
      let apiUrl="/api/Config/Index"
      this.http.post<any>(apiUrl,this.sectormodel)
      .subscribe(data => {
        this.result=data;
        if(this.result["RuleError"]==null){
        this.callExceptionArray()}        
      });

    } else {
      this.result["WordError"] = "Sector and Model have not been selected!";
    }
  }

  exceptionDelete(deleteObj: JSON){
    this.exceptionlist.slice(this.exceptionlist.indexOf(deleteObj), 1);
    // console.log("deleteobj "+JSON.stringify(deleteObj));
    let apiUrl = "/api/Config/DeleteWord"
    this.http.post<any>(apiUrl,deleteObj)
    .subscribe(data=>{
      console.log("Exception word deleted ");
    this.callExceptionArray();
    
    })
  }

  ExceptionCreate(){

    const data = {
      
      "Sector": this.dbconnectorservice.SectorName,
      "Model": this.dbconnectorservice.ModelName,
      "Exception": this.ExceptionName

    };

    this.exceptionlist.push(this.ExceptionName);
    // console.log(" data " + JSON.stringify(data));
    let apiUrl="/api/Config/InsertWord";

    this.http.post<any>(apiUrl,data)
    //.catch(error => Observable.throw(error))
    .subscribe(
    result => {console.log(result)
    this.callExceptionArray();}
    //error => console.log("error");
    )
  }

  callExceptionArray(){

    let apiUrl="/api/Config/GetWords"
    this.http.post<any>(apiUrl,{"SectorName": this.dbconnectorservice.SectorName})
    .subscribe(data => {
      this.exceptionlist = data;
      if (this.exceptionlist.length >0){
        this.NoWords = false;
      }
    }
    )
  }

  ngOnInit() {

      this. callIndex();
    
    // console.log("exceptionlist1 "+this.exceptionlist);
    // console.log("exceptionlist2 "+JSON.stringify(this.exceptionlist));

  }
  ngOnDestroy(){
    this.Sub.unsubscribe();
  }

}
